import React, { useState } from 'react';
import './AddSystemModal.css';

const AddSystemModal = ({ onSubmit, onCancel }) => {
  const [systemName, setSystemName] = useState('');
  const [expiryMonths, setExpiryMonths] = useState(12);
  const [offlineGraceHours, setOfflineGraceHours] = useState(72);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!systemName.trim()) {
      setError('System name is required');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await onSubmit({
        systemName: systemName.trim(),
        expiryMonths: parseInt(expiryMonths, 10) || 12,
        offlineGraceHours: parseInt(offlineGraceHours, 10) || 72,
      });
    } catch (err) {
      setError(err.message || 'Failed to add system');
      setSubmitting(false);
    }
  };

  return (
    <div className="add-system-overlay" onClick={onCancel}>
      <div className="add-system-modal" onClick={(e) => e.stopPropagation()}>
        <div className="add-system-header">
          <h3>Add System</h3>
          <button type="button" className="add-system-close" onClick={onCancel}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit} className="add-system-form">
          <label>
            <strong>System name *</strong>
            <input
              type="text"
              value={systemName}
              onChange={(e) => setSystemName(e.target.value)}
              placeholder='e.g. "Billing PC"'
              required
            />
          </label>
          <label>
            <strong>Validity (months)</strong>
            <input
              type="number"
              min="1"
              max="120"
              value={expiryMonths}
              onChange={(e) => setExpiryMonths(e.target.value)}
            />
          </label>
          <label>
            <strong>Offline grace (hours)</strong>
            <input
              type="number"
              min="1"
              max="720"
              value={offlineGraceHours}
              onChange={(e) => setOfflineGraceHours(e.target.value)}
            />
          </label>
          {error && <div className="add-system-error">{error}</div>}
          <div className="add-system-actions">
            <button type="button" onClick={onCancel} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" disabled={submitting}>
              {submitting ? 'Adding…' : 'Add System & License'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSystemModal;
